<template>
    <div class="page-setup">
    <div class="container">

        <div class="is-flex-desktop page-setup-header">
            <div class="setup-title">Guarde os seus links favoritos de forma organizada.</div>
            <div class="setup-next"><button class="button next" @click="onNext">Salvar e avançar</button></div>
        </div>
        <div class="setup-subtitle">Recomendamos algumas opções de categorias para você começar.</div>

        <div class="example"><i></i><span>Marque ou desmarque as categorias que desejar e crie novas à sua escolha.</span></div>


        <div class="setup-categories">

            <div v-for="category in categories" class="setup-category" :class="{sponsored:category.isSponsored}" :key="category.name">
                <label>
                    <input type="checkbox" v-model="category.isChecked">
                    <i></i>
                    <span>{{ category.name }}</span>
                    <ins v-if="category.isSponsored && category.sponsorInfo" :title="category.sponsorInfo">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20,12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M11,17H13V11H11V17Z" /></svg>
                    </ins>
                </label>
            </div>

            <div class="category-add">
                <label @click="openForm">
                    <i></i>
                    <span>Criar outras categorias</span>
                </label>
            </div>

        </div>

        <p>Seus links estarão guardados em caixas/categorias para você acessar sempre que precisar</p>

        <div class="page-setup-footer is-hidden-desktop">
          <div class="setup-next"><button class="button next" @click="onNext">Salvar e avançar</button></div>
        </div>

        <div v-if="formAdd" class="modal is-active" >
            <div class="modal-background"></div>
            <div class="modal-card">
                <header class="modal-card-head">
                    <p class="modal-card-title">
                        Adicione novas categorias
                    </p>
                    <button class="delete" aria-label="close" @click="goBack"></button>
                </header>
                <form @submit.prevent="onSubmit()">

                    <section class="modal-card-body">


                        <div class="field" v-for="(category,index) in newCategories" :key="index">
                            <div class="control">
                                <div class="field has-addons">
                                    <input class="input" type="text" v-model="category.name" placeholder="Nome">
                                    <button v-if="index>0" class="button" @click.prevent="removeRow(index)">&times;</button>
                                </div>
                            </div>
                        </div>
                        <button class="button" @click.prevent="addRow">adicionar linha</button>

                    </section>
                    <footer class="modal-card-foot">
                        <button type="submit" class="button is-success">Salvar</button>
                        <button class="button" @click.prevent="goBack">Voltar</button>
                    </footer>
                </form>
            </div>
        </div>


    </div>
    </div>


</template>
<style>

    .page-setup-header { justify-content: flex-start; }
    .page-setup .setup-title { flex-basis: 66.66%; }
    .page-setup .setup-next { flex-basis: 33.33%; }

.page-setup { padding:80px 0; background-color:#eeeeee; }

.setup-title {font-size: 30px;font-weight: bold;margin-bottom: 5px;}
.setup-subtitle {font-size: 23px;font-weight: 300;color: #999;}
.page-setup p {color: #999;font-size: 22px;font-weight: 300;text-align: center;margin-bottom: 25px;}
.example {margin: 20px auto;width: 630px;/* justify-content: center; */background: #fff;padding: 15px 30px;border-radius: 15px;border: 1px solid #ccc;/* align-items: center; */}
.example i {
  display: inline-block;
  font-style: normal;
  width: 22px;height: 22px;
  border-radius: 3px;
  border: 1px solid #ccc;
  position: relative;
  margin: 0 10px 0 0;
  text-align: center;
  line-height: 22px;

}
.example i:after{
  content:"\2714"; /* ✓ 2713 ✔ 2714 */
}
.example span {font-weight: 300;}



.setup-categories{display: flex;flex-wrap: wrap;justify-content: space-between; max-width: 1100px; margin: 0 auto 40px; }
.setup-category { flex-basis:33.33%;
flex-basis:calc(33.33% - 5px);
margin-bottom:5px;
  padding:5px; }
.setup-category label {display: inline-block;cursor: pointer;padding:10px;/* background:#fff; *//* border:1px solid red; */font-weight: 400;font-size: 20px;}
.setup-category i {
  display: inline-block;
  font-style: normal;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-top: 1px solid #ccc;
  background:#fff;
  position: relative;
  margin: 0 10px 0 0;
  text-align: center;
  border-radius: 3px;
}
.setup-category i { color:#fff; }
.setup-category i:after {
  content: " ";
  color:#fff;
  font-size: 25px;
}
.setup-category input[type=checkbox] { display:none;}
.setup-category input[type=checkbox]:checked + i { color:#2cc6ba; }
.setup-category input[type=checkbox]:checked + i:after { content:"\2714"; color:#2cc6ba; }
.setup-category span { position: relative; }
.page-setup .sponsored { background:#dbdbdb; position: relative; }
.page-setup .sponsored span {    color: #00b3bc; font-weight: bold; }
.page-setup .sponsored span:after {
  content:'em destaque'; position: absolute;top:20px;left:0; font-size: 12px;opacity: .6;
  color: #333;
    font-weight: 400;
}
.setup-category ins { position: absolute; top:5px; right:5px; width:20px; height:20px; }
.setup-category ins svg { display: block;height: 100%; width: 100%; }
.setup-category ins svg path { fill:#00b3bc; }

.category-add { flex-basis:33.33%;
flex-basis:calc(33.33% - 5px);
margin-bottom:5px;
  padding:5px; background: #00b3bc; }
.category-add label {display: inline-block;cursor: pointer;padding:10px;font-size: 20px;}
.category-add i {
  display: inline-block;
  font-style: normal;
  width: 30px;
  height: 30px;
  line-height: 30px;
  border-top: 1px solid #8e8e8e;
  background:#fff;
  position: relative;
  margin: 0 10px 0 0;
  text-align: center;
  border-radius: 3px;
  font-size: 30px;
}
.category-add i:after {
  content:"+";
  color:#2cc6ba;
}
.category-add span {color: #fff; font-weight: bold;}



.next{background: #2cc6ba;border: 0;color: #fff;font-size: 22px;padding: 10px 50px;display: block;border-radius: 10px;box-shadow: 1px 3px 4px rgba(0,0,0,0.4); width:272px;}
.next:hover {color:#fff;background: #3fd5c8;}

body.is-mobile .page-setup { padding:40px 20px 60px; }
body.is-mobile .page-setup-header { text-align:center; }
body.is-mobile .page-setup-header .setup-next { display: none  }
body.is-mobile .setup-subtitle { text-align:center; }
body.is-mobile .example { max-width: 100%; padding:15px;  }
body.is-mobile .setup-categories { display: block; }
body.is-mobile .page-setup-footer button.next { margin:0 auto; }

</style>
<script>

/* eslint-disable no-console */
//import firebase from 'firebase';
import firebase from '@/firebase'
export default {
    name: 'setup',
    data(){
        return {
            db: null,
            formAdd:false,

            newCategories: [
                {name:''},
            ],
            categories:[],

        }
    },
    computed: {
        userIsAnonymous() {
          return this.$store.state.user.isAnonymous==true
        },
        userId() {
            return this.$store.getters.userId;
        },
    },
    methods: {
        openForm(){
            this.formAdd=true;
        },
        addRow(){
            this.newCategories.push({name:''});
        },
        removeRow(index){
            this.newCategories.splice(index,1);
        },
        onSubmit(){
            let i;
            for(i in this.newCategories){
                if(this.newCategories[i].name){
                     //&& this.categories.indexOf(this.newCategories[i].name)===-1
                    this.categories.push({name:this.newCategories[i].name, isChecked:true});
                }
            }
            this.goBack();
        },
        onNext(){
            console.log('setup onnext')

            this.$store.dispatch('startLoading');
            this.$store.dispatch('setLoadingMessage',{message:'Estamos organizando tudo para você. Isto pode levar 1 minuto.'});


//            query
//            first get user id

            let userRef = this.db.collection('users').doc(this.userId);

            let batch = this.db.batch();

            let i,l = 0;
            let column = 1;
            let index = 1;

            let selectedCategories = this.categories.filter(item=>item.isChecked);


            for(i in selectedCategories){

                var category = selectedCategories[i];

                category.slug = category.name.replace(/[\s/]+/g,'-').toLowerCase();

                let categoryRef = userRef.collection('categories').doc(category.slug);
                batch.set(categoryRef, {
                    name:category.name,
                    column:column,
                    index:index,
                });

                if(category.links) for(l in category.links){

                    let newLink = userRef.collection('links').doc();
                    batch.set(newLink, {
                        name:category.links[l].name,
                        url:category.links[l].url,
                        category_id:category.slug,

                    });
                }


                if(++column>3) {
                  column = 1;
                  index++;
                }

            }

            var categoria_flamengo_selecionada = selectedCategories.filter(item=>item.name.toUpperCase() == 'FLAMENGO')
            if(getCookie('tema')=='flamengo' || categoria_flamengo_selecionada.length){
              this.$store.dispatch('setTheme',{theme:'tema15'});
              this.$store.dispatch('setTransparency',{transparency:40});
            }

            userRef.update({setup:true});

            batch.commit();

            this.$store.dispatch('stopLoading');

            this.$router.push({name:'home'});

        },
        goBack(){
            this.formAdd=false;
        }
    },
    mounted(){
        this.db = firebase.firestore();
        console.log('tela setup - this.userIsAnonymous',this.userIsAnonymous);

        if(this.$store.state.config.isLoaded){
            this.categories = this.$store.state.config.defaultCategories;
            if(this.userIsAnonymous) this.onNext();
        } else {
            this.$store.dispatch('startLoading');
            this.db.collection('admin').doc('config').get().then(doc => {
                var config = doc.data();
                config.isLoaded = true;
                this.categories = config.defaultCategories;
                this.$store.dispatch('stopLoading');
                if(this.userIsAnonymous) this.onNext();
            })
        }


    }
}
</script>
